export default "__VITE_ASSET__C6KiWNfM__"